import React from 'react';
import { Skeleton, SkeletonContent, SkeletonLine, SkeletonBlock } from '@one-thd/sui-atomic-components';
import proptypes from 'prop-types';

const { bool } = proptypes;

export const Loader = (props) => {
  const { large } = props;

  return (
    <div className="sui-w-full sui-h-full">
      {large
        ? (
          <div className="sui-w-full sui-h-full">
            <Skeleton disablePadding orientation="vertical" grow>
              <SkeletonContent density="loose" disablePadding initialSize="4/4">
                <SkeletonBlock aspect="wide" />
              </SkeletonContent>
              <SkeletonContent density="loose" disablePadding initialSize="4/4">
                <SkeletonBlock aspect="wide" />
              </SkeletonContent>
              <SkeletonContent density="loose" disablePadding initialSize="4/4">
                <SkeletonBlock aspect="wide" />
              </SkeletonContent>
            </Skeleton>
          </div>
        )
        : (
          <div className="sui-w-full sui-h-full">
            <Skeleton disablePadding orientation="horizontal" grow>
              <SkeletonContent density="loose" disablePadding initialSize="4/4">
                <SkeletonBlock aspect="wide" />
              </SkeletonContent>
              {/* <SkeletonContent density="loose" disablePadding="x" initialSize="3/4">
                <SkeletonLine numberOfLines={3} />
              </SkeletonContent> */}
            </Skeleton>
          </div>
        )}
    </div>
  );
};

Loader.displayName = 'SuperSkuLoader';

Loader.propTypes = {
  large: bool,
};

Loader.defaultProps = {
  large: false,
};
